import initialParametersReducer from './InitialParameters/initial.toolkit';

export * from './types';
export const mainReducer = { initialParameters: initialParametersReducer };
